import { useEffect } from 'react'
import '../Contacto/modal.css'
import { useLangContext } from '../../Context/LangContext'
import homeTexts from '.././utils/Texts/homeTexts.json'

const ModalRent = ({ toggleModal }) => {
  const { selectedLanguage } = useLangContext()
  const text = homeTexts[selectedLanguage]

  useEffect(() => {
    // Verificamos si el widget ya está montado
    const alreadyInitialized = document.getElementById('rental_widget_script')
    if (alreadyInitialized) return

    const script = document.createElement('script')
    script.id = 'rental_widget_script' // Le damos un ID único
    script.type = 'module'
    script.innerHTML = `
      import { RentalGuaranteeWidget } from "https://test.widgets.winse.online/winse_integration_worker.js";
      if (!window.__rentalWidgetLoaded) {
        const rental_widget = new RentalGuaranteeWidget('widget_container', 'pk-5e03433c-7b11-4b55-bef9-e2f347480cc7');
        rental_widget.init();
        window.__rentalWidgetLoaded = true;
      }
    `
    document.body.appendChild(script)

    // 🔴 Cleanup al desmontar: eliminamos script y la marca global
    return () => {
      const existingScript = document.getElementById('rental_widget_script')
      if (existingScript) {
        existingScript.remove()
        delete window.__rentalWidgetLoaded
      }

      // También eliminamos el contenido del widget_container si quedó algo dentro
      const container = document.getElementById('widget_container')
      if (container) {
        container.innerHTML = ''
      }
    }
  }, [])

  return (
    <div className="modal-overlay">
      <div className="modal-content-rent">
        <div className="modal-header">
          <h2>
            {text.productButton}
          </h2>
        </div>

        <div id="widget_container" />

        <div className="modal-buttons-rent">
          <button className="modal-button-close" onClick={toggleModal}>
            {text.closeButton}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalRent
